__turbopack_context__.v({
  "divider": "AdminTopBar-module__G7ZJBq__divider",
  "left": "AdminTopBar-module__G7ZJBq__left",
  "right": "AdminTopBar-module__G7ZJBq__right",
  "root": "AdminTopBar-module__G7ZJBq__root",
});
